import BarChartItemModel from './BarChartItemModel';

const BarChartElementModel = {
  elements: [BarChartItemModel],
};

export default BarChartElementModel;
